document.addEventListener("DOMContentLoaded", function () {
    var swiper = new Swiper('.services-grid-slider', {
        slidesPerView: 1,
        spaceBetween: 30,
        loop:true,
        direction: 'horizontal',
        navigation: {
            nextEl: '.services-grid-button-next',
            prevEl: '.services-grid-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        breakpoints: {
            767: {
                slidesPerView: 2,
                direction: 'horizontal',
            },
            1200: {
                slidesPerView: 3,
                direction: 'horizontal',
            },
        },
    });
});